import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'sis-validation-summary',
	templateUrl: './sis-validation-summary.component.html',
	styleUrls: ['./sis-validation-summary.component.scss'],
	imports: [CommonModule, TranslateModule],
})
export class SisValidationSummaryComponent {
	private readonly defaultValidatorMessages: Record<string, string> = {
		required: 'form.validation.required',
		maxlength: 'form.validation.maxlength',
		minlength: 'form.validation.minlength',
		pattern: 'form.validation.pattern',
		email: 'form.validation.sistek-email-pattern',
		max: 'form.validation.max',
		min: 'form.validation.min',
	};

	private _validatorMessages: Record<string, string> = {
		...this.defaultValidatorMessages,
	};

	@Input() public name: string = '';
	@Input() public form: FormGroup | AbstractControl = new FormGroup({});
	@Input() public visible: boolean = false;
	/**
	 * Örnek kullanım:
	 * <sis-validation-summary [validatorMessages]="{ underage: 'form.validation.underage' }"></sis-validation-summary>
	 */
	@Input()
	set validatorMessages(value: Record<string, string> | null | undefined) {
		this._validatorMessages = {
			...this.defaultValidatorMessages,
			...(value ?? {}),
		};
	}

	get validatorMessages(): Record<string, string> {
		return this._validatorMessages;
	}
	constructor() {}

	public isInvalid(): boolean {
		if (!this.name) {
			return this.form.invalid && (this.form.dirty || this.form.touched);
		} else {
			if (this.form.get(this.name) == undefined) {
				console.warn(`form control is not defined ‾\\_(*_*)_/‾ ${this.name}`);
				return false;
			}
			const ctrl = this.control;
			return ctrl ? ctrl.invalid && (ctrl.dirty || ctrl.touched) : false;
		}
	}

	get control(): AbstractControl | null {
		if (this.name) {
			return this.form.get(this.name);
		} else {
			return this.form;
		}
	}

	public get visibleErrors(): ValidationErrorEntry[] {
		const ctrl = this.control;
		if (!ctrl || !ctrl.errors) {
			return [];
		}

		return Object.entries(ctrl.errors)
			.filter(([key]) => !!this._validatorMessages[key])
			.map(([key, value]) => ({
				key,
				translationKey: this._validatorMessages[key],
				value: value as ValidationErrorPayload,
			}));
	}
}

/** Alan bazlı validator hata objesi (örn. max/min için translate parametreleri). */
interface ValidationErrorPayload {
	max?: number;
	min?: number;
}

interface ValidationErrorEntry {
	key: string;
	translationKey: string;
	value: ValidationErrorPayload;
}
